var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B3B3B3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150,150c28.2,0,51-22.9,51-51c0-28.2-22.8-51-51-51S99,70.8,99,99C99,127.1,121.8,150,150,150z M150,175.5 c-34,0-102,17-102,51V252h204v-25.5C252,192.5,184,175.5,150,175.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPhoto);
export default __webpack_public_path__ + "static/media/defaultPhoto.51c3075d8ce39c834beb9564b580ae00.svg";
export { ForwardRef as ReactComponent };